import { getCurrentInstance, ref, watch } from 'vue'
import { ANALYTICS_CONSTS } from '../store'
import { useContextQuery } from './use-context-query'
import { useFilters } from './use-filters'
import { mapActions } from './utils'

export function useReloadDistDataWhenFiltersChange() {
  const {
    proxy: { $store },
  } = getCurrentInstance() as { proxy: Vue }

  const isLoading = ref(false)
  const { query } = useContextQuery()
  const { filters } = useFilters()

  const {
    loadDistData,
    reset: resetDistData,
    setSelectedId,
  } = mapActions($store, ANALYTICS_CONSTS.moduleName, {
    loadDistData: ANALYTICS_CONSTS.actions.loadDistData,
    reset: ANALYTICS_CONSTS.actions.reset,
    setSelectedId: ANALYTICS_CONSTS.actions.setSelectedId,
  })

  watch(filters, async (): Promise<void> => {
    isLoading.value = true
    await resetDistData()
    await setSelectedId(query.value)
    await loadDistData(query.value)
    isLoading.value = false
  })

  return { isLoading }
}
